import { getUserState } from '@juvare/platform-sdk-react/ui/stores';
import { useSelector } from 'react-redux';
export function useUserState() {
    return useSelector(getUserState);
}
